import {
  ApolloClient,
  ApolloLink,
  fromPromise,
  InMemoryCache
} from '@apollo/client';
import { HttpLink } from '@apollo/client';
import Appconfig from '@config/index';
import introspectionQueryResultData from '@generated/fragmentTypes.json';
import {
  clearStorageAll,
  getStorageItem,
  STORAGE_ACTION
} from '@utils/storage';
import { onError } from '@apollo/client/link/error';
import { tokenRefresh } from './utils';

const httpLink = new HttpLink({
  uri: `https://${Appconfig.graphqlUrl}`
  // Additional options
});

const authLink = new ApolloLink((operations, forward) => {
  const accessToken = getStorageItem(STORAGE_ACTION.ACCESS_TOKEN);
  operations.setContext({
    headers: {
      authorization: `Bearer ${accessToken}`
    }
  });
  return forward(operations);
});

const errorLink = onError(({ forward, operation, graphQLErrors }) => {
  if (graphQLErrors && graphQLErrors.length > 0) {
    for (let error of graphQLErrors) {
      const { message } = error;

      /* 토큰이 만료된 경우 refresh 실행 */
      if (message === 'TOKEN_EXPIRED' || message.includes('JWTExpired')) {
        const prevHeaders = operation.getContext()?.headers;

        // onError 함수내에서 비동기 함수 처리 (RxJS, apollo-link)
        return fromPromise(tokenRefresh().then((token) => token))
          .filter((token) => Boolean(token))
          .flatMap((token) => {
            // operation의 header를 재설정
            operation.setContext(() => ({
              headers: {
                ...prevHeaders,
                authorization: `Bearer ${token}`
              }
            }));

            // 실패한 요청 재실행
            return forward(operation);
          });
      }

      /* 토큰이 없거나, 잘못된 토큰인 경우 인증관련 내용 삭제 및 login 페이지로 이동 */
      if (message === 'INVALID_TOKEN') {
        clearStorageAll();
        window.location.reload();
      }
    }
  }
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache({
    possibleTypes: introspectionQueryResultData.possibleTypes
  })
});

export default apolloClient;
